import {
  before1,
  roofbefore,
  before3,
  after1,
  roofafter,
  after3,
  before5,
  after5,
  before6,
  after6,
  before7,
  after7,
  before8,
  after8,
  before4,
  after4,
  before9,
  after9,
  before10,
  after10,
  after11,
  before11,
  before12,
  after12,
  before13,
  after13,
  before14,
  after14,
  before15,
  after15,
  before16,
  after16,
  before17,
  after17,
  before18,
  after18,
  before19,
  after19,
  after22,
  before22,
} from "../assets/Gallery/Index";

const data = [
  {
    img1: before1,
    img2: after1,
  },
  {
    img1: before22,
    img2: after22,
  },
  {
    img1: before19,
    img2: after19,
  },

  {
    img1: before3,
    img2: after3,
  },
  {
    img1: before4,
    img2: after4,
  },
  {
    img1: before5,
    img2: after5,
  },
  {
    img1: before6,
    img2: after6,
  },
  {
    img1: before7,
    img2: after7,
  },
  {
    img1: before8,
    img2: after8,
  },
  {
    img1: roofbefore,
    img2: roofafter,
  },
  {
    img1: before9,
    img2: after9,
  },
  {
    img1: before10,
    img2: after10,
  },
  {
    img1: before11,
    img2: after11,
  },
  {
    img1: before12,
    img2: after12,
  },
  {
    img1: before13,
    img2: after13,
  },
  {
    img1: before14,
    img2: after14,
  },
  {
    img1: before15,
    img2: after15,
  },

  {
    img1: before17,
    img2: after17,
  },
  {
    img1: before18,
    img2: after18,
  },
];

export default data;
